import { BaseTool } from './BaseTool';
import { ToolType } from '../types';

export class MoveTool extends BaseTool {
  public id: ToolType = 'move';
  public name = 'Move & Transform Tool';
  public cursor = 'move';

  private isDragging = false;
  private startMouseX = 0;
  private startMouseY = 0;
  private startLayerX = 0;
  private startLayerY = 0;

  public onMouseDown(e: MouseEvent, canvasX: number, canvasY: number): void {
    const layer = this.editor.getActiveLayer();
    if (!layer || layer.locked) return;

    this.isDragging = true;
    this.startMouseX = canvasX;
    this.startMouseY = canvasY;
    this.startLayerX = layer.x;
    this.startLayerY = layer.y;
  }

  public onMouseMove(e: MouseEvent, canvasX: number, canvasY: number): void {
    if (!this.isDragging) return;
    const layer = this.editor.getActiveLayer();
    if (!layer || layer.locked) return;

    const dx = canvasX - this.startMouseX;
    const dy = canvasY - this.startMouseY;

    layer.x = Math.round(this.startLayerX + dx);
    layer.y = Math.round(this.startLayerY + dy);
    this.editor.render();
  }

  public onMouseUp(_e: MouseEvent): void {
    if (this.isDragging) {
      this.isDragging = false;
      this.editor.recordHistory('Move Layer');
    }
  }

  public renderOverlay(ctx: CanvasRenderingContext2D): void {
    const layer = this.editor.getActiveLayer();
    if (!layer) return;

    // Draw bounding box around active layer
    const zoom = this.editor.zoom;
    const panX = this.editor.panX;
    const panY = this.editor.panY;

    const lx = (layer.x) * zoom + panX;
    const ly = (layer.y) * zoom + panY;
    const lw = layer.width * zoom;
    const lh = layer.height * zoom;

    ctx.save();
    ctx.strokeStyle = '#3b82f6';
    ctx.lineWidth = 1.5;
    ctx.strokeRect(lx, ly, lw, lh);

    // Draw 8 transformation handles
    const handleSize = 7;
    const handles = [
      [lx, ly],
      [lx + lw / 2, ly],
      [lx + lw, ly],
      [lx + lw, ly + lh / 2],
      [lx + lw, ly + lh],
      [lx + lw / 2, ly + lh],
      [lx, ly + lh],
      [lx, ly + lh / 2]
    ];

    ctx.fillStyle = '#ffffff';
    ctx.strokeStyle = '#2563eb';
    ctx.lineWidth = 1.5;
    handles.forEach(([hx, hy]) => {
      ctx.fillRect(hx - handleSize / 2, hy - handleSize / 2, handleSize, handleSize);
      ctx.strokeRect(hx - handleSize / 2, hy - handleSize / 2, handleSize, handleSize);
    });

    ctx.restore();
  }
}
